import { createAction } from 'redux-actions'

const ns = 'router/'

export const reLocate = createAction(`${ns}RELOCATE`)
